export default "__VITE_ASSET__9ea2c854__"